export function parseUTC(s) {
  if (!s) return '';
  s = String(s);
  if (s.match(/[Z+-]\d{2}:\d{2}$/) || s.endsWith('Z')) return s;
  return s.replace(' ', 'T') + 'Z';
}
export function formatDate(d) {
  if (!d) return '';
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const dt = new Date(parseUTC(dateStr));
  if (isNaN(dt.getTime())) return '';
  const mins = Math.round((now - dt) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return mins + 'm ago';
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return hrs + 'h ago';
  const days = Math.round(hrs / 24);
  if (days < 7) return days + 'd ago';
  return Math.round(days / 7) + 'w ago';
}
export function formatFlightTime(f) {
  const src = f.landing_time;
  if (src) {
    const dt = new Date(parseUTC(src));
    if (isNaN(dt.getTime())) return formatDate(f.flight_date);
    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
  }
  return formatDate(f.flight_date);
}
export function formatDetailTime(s) {
  if (!s) return null;
  const dt = new Date(parseUTC(s));
  if (isNaN(dt.getTime())) return null;
  return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'America/New_York' })
    + ' at ' + dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', timeZone: 'America/New_York' }) + ' EST';
}
